var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C23.4315 12.6986 24.1875 13.6045 24.7082 14.6459C25.2289 15.6873 25.5 16.8357 25.5 18C25.5 19.1643 25.2289 20.3127 24.7082 21.3541C24.1875 22.3955 23.4315 23.3014 22.5 24",
    stroke: "#FFE4A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5508 7.5C28.1167 8.76548 29.3798 10.3652 30.2475 12.182C31.1152 13.9988 31.5655 15.9866 31.5655 18C31.5655 20.0134 31.1152 22.0012 30.2475 23.818C29.3798 25.6348 28.1167 27.2345 26.5508 28.5",
    stroke: "#FFE4A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.5003H6C5.60218 22.5003 5.22064 22.3423 4.93934 22.061C4.65804 21.7797 4.5 21.3982 4.5 21.0003V15.0003C4.5 14.6025 4.65804 14.221 4.93934 13.9397C5.22064 13.6584 5.60218 13.5003 6 13.5003H9L14.25 6.75033C14.3811 6.49567 14.599 6.29631 14.8642 6.18826C15.1295 6.08022 15.4247 6.07062 15.6964 6.16119C15.9681 6.25176 16.1985 6.43654 16.3458 6.68214C16.4932 6.92773 16.5479 7.21794 16.5 7.50033V28.5003C16.5479 28.7827 16.4932 29.0729 16.3458 29.3185C16.1985 29.5641 15.9681 29.7489 15.6964 29.8395C15.4247 29.93 15.1295 29.9204 14.8642 29.8124C14.599 29.7043 14.3811 29.505 14.25 29.2503L9 22.5003Z",
    stroke: "#FFE4A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.c255410150c026ed345d031aa8a12047.svg";
export { ForwardRef as ReactComponent };